import './component.scss'

export class ServicesTabs
{

	constructor(id, params, result)
	{
		this.id = id
		this.params = params
		this.result = result
		this.$component = document.getElementById(this.id)

		this.init()
	}

	init()
	{
		this.initEvents()
	}

	initEvents()
	{
        let self = this,
            $elements = this.$component.querySelectorAll('.js-service-tabs-opener')

        for (let $element of $elements) {
            $element.addEventListener('click', function (e) {
                self.toggleTab(this)
            })
        }
    }
    
    toggleTab($link)
    {
        $link.parentNode.classList.toggle('is-selected')
    }

}
